import { useContext } from 'react'
import { MarkupContext } from '../../providers/Markup'
import CuratedCardTitle from './CuratedCardTitle'

const titleLayoutClass = 'mb-4 mt-auto'

const alignmentClass = (cardItem) =>
  cardItem.titleAlignment ? `text-${cardItem.titleAlignment.toLowerCase()}` : ''

const HeroTitle = ({ type, cardItem, idx, titleClass, className, onCardClick }) => {
  const { createMarkup } = useContext(MarkupContext)
  const resolvedClassName = [titleClass, className].filter(Boolean).join(' ')

  const mapped = {
    title: 'title',
  }

  if (type === 'dynamic') {
    mapped.title = 'listingTitle'
  }

  if (type === 'curated') {
    const titleContent = (
      <CuratedCardTitle
        title={cardItem.title}
        useSmallTitle={cardItem.useSmallTitle}
        titleAlignment={cardItem.titleAlignment}
        className={titleLayoutClass}
      />
    )

    if (cardItem.ctaLinkItem && cardItem.ctaLinkItem?.length !== 0) {
      return (
        <a
          href={cardItem.ctaLinkItem[0].link?.url}
          target={cardItem.ctaLinkItem[0].link?.target ?? '_self'}
          onClick={onCardClick}
          className={resolvedClassName}
        >
          {titleContent}
        </a>
      )
    }

    if (cardItem.listingLink && cardItem.listingLink?.length !== 0) {
      return (
        <a href={cardItem.listingLink} onClick={onCardClick} className={resolvedClassName}>
          {titleContent}
        </a>
      )
    }

    return (
      <div className={resolvedClassName}>
        {titleContent}
      </div>
    )
  }

  if (cardItem.ctaLinkItem && cardItem.ctaLinkItem?.length !== 0) {
    return (
      <a href={cardItem.ctaLinkItem[0].link?.url} target={cardItem.ctaLinkItem[0].link?.target ?? '_self'} onClick={onCardClick} className={resolvedClassName}>
        <div
          className={`block ${titleLayoutClass} ${alignmentClass(cardItem)}`}
          data-rte="true"
          dangerouslySetInnerHTML={createMarkup(cardItem[mapped.title])}
        ></div>
      </a>
    )
  } else if (cardItem.listingLink && cardItem.listingLink?.length !== 0) {
    return (
      <a href={cardItem.listingLink} onClick={onCardClick} className={resolvedClassName}>
        <div
          className={`block ${titleLayoutClass} ${alignmentClass(cardItem)}`}
          data-rte="true"
          dangerouslySetInnerHTML={createMarkup(cardItem[mapped.title])}
        ></div>
      </a>
    )
  }

  return (
    <div
      className={`block ${titleLayoutClass} ${alignmentClass(cardItem)} ${resolvedClassName}`}
      data-rte="true"
      dangerouslySetInnerHTML={createMarkup(cardItem[mapped.title])}
    ></div>
  )
}

export default HeroTitle
